import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './TextBox.module.scss';
export function TextBox(param) {
    let { children, className } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.textbox, className),
        children: children
    });
}
